<ion-content class="ion-padding">
  <usucampeao-dados-imovel [projeto]="projeto$ | async" [dadosImovel]="dadosImovel"
    (aoSubmeter)="criarCadastroOuAtualizarDadosImovel($event)">
  </usucampeao-dados-imovel>
</ion-content>
